import { render } from "./AtomLabel.vue?vue&type=template&id=4e397fae&ts=true"
import script from "./AtomLabel.vue?vue&type=script&lang=ts"
export * from "./AtomLabel.vue?vue&type=script&lang=ts"

import "./AtomLabel.vue?vue&type=style&index=0&id=4e397fae&lang=scss"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__